import {
    DEALERSETDSRLIMITS_FAILED,
    DEALERSETDSRLIMITS_SUCCESS,
    RESET_DEALERSETDSRLIMITS,
    LOADING_DEALERSETDSRLIMITS,
    NETWORK_ERROR_DEALERSETDSRLIMITS
} from '../types/index';

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERSETDSRLIMITS:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERSETDSRLIMITS_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERSETDSRLIMITS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERSETDSRLIMITS:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERSETDSRLIMITS:
            return (state = initialState);
        default:
            return state;
    }
};